import { SIDEBAR_UPGRADE_MODE, type SidebarUpgradeMode } from '../consts';

/**
 * Decides which sidebar upgrade surface to render.
 *
 * Self-serve users get the state-colored self-serve widget regardless of role
 * (owner or member) — matching the top-bar billing pill's gating. Non-self-serve
 * users who are allowed on the plans page get the legacy upgrade button. Everyone
 * else (members of non-self-serve accounts, enterprise) gets nothing.
 *
 * @param selfServeAllowed whether the account is self-serve (from useSelfServeGate)
 * @param isPlansPageAllowed whether the user may reach the plans page (owner-scoped)
 * @returns the upgrade surface to render: self-serve widget, legacy button, or hidden
 */
export const getSidebarUpgradeMode = (
  selfServeAllowed: boolean,
  isPlansPageAllowed: boolean,
): SidebarUpgradeMode => {
  if (selfServeAllowed) {
    return SIDEBAR_UPGRADE_MODE.SELF_SERVE;
  }

  if (isPlansPageAllowed) {
    return SIDEBAR_UPGRADE_MODE.LEGACY;
  }

  return SIDEBAR_UPGRADE_MODE.HIDDEN;
};
